import styled from 'styled-components'

export const StyledTitle = styled.h2`
  margin: 0;
  padding-bottom: 1.5em;
  text-align: center;
`
